export function getFirebaseErrorKey(error: any): string {
    const message = String(
        error?.message ??
            error?.customData?._serverResponse?.error?.message ??
            "",
    );

    if (message.includes("TOTP based MFA not enabled")) {
        return "FIREBASE.ERROR.TOTP_MFA_NOT_ENABLED.TEXT";
    }

    const errorMap: { [key: string]: string } = {
        "auth/requires-recent-login":
            "FIREBASE.ERROR.REQUIRES_RECENT_LOGIN.TEXT",
        "auth/network-request-failed":
            "FIREBASE.ERROR.NETWORK_REQUEST_FAILED.TEXT",
        "auth/user-token-expired": "FIREBASE.ERROR.USER_TOKEN_EXPIRED.TEXT",
        "auth/user-disabled": "FIREBASE.ERROR.USER_DISABLED.TEXT",
        "auth/user-not-found": "FIREBASE.ERROR.USER_NOT_FOUND.TEXT",
        "auth/operation-not-allowed":
            "FIREBASE.ERROR.OPERATION_NOT_ALLOWED.TEXT",
        "auth/too-many-requests": "FIREBASE.ERROR.TOO_MANY_REQUESTS.TEXT",
        "auth/internal-error": "FIREBASE.ERROR.INTERNAL_ERROR.TEXT",
        "auth/invalid-verification-code":
            "FIREBASE.ERROR.INVALID_TOTP_CODE.TEXT",
        "auth/internal-error-encountered": "FIREBASE.ERROR.INTERNAL_ERROR.TEXT",
        "auth/wrong-password": "FIREBASE.ERROR.WRONG_PASSWORD.TEXT",
        "auth/invalid-mfa-enrollment-id":
            "FIREBASE.ERROR.INVALID_MFA_ENROLLMENT_ID.TEXT",
        "auth/quota-exceeded": "FIREBASE.ERROR.QUOTA_EXCEEDED.TEXT",
        "auth/invalid-credential":
            "FIREBASE.ERROR.INVALID_LOGIN_CREDENTIALS.TEXT",
    };

    if (error?.code && errorMap[error.code]) {
        return errorMap[error.code];
    }

    return "FIREBASE.ERROR.UNKNOWN_ERROR.TEXT";
}
